import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { Loader2, CheckCircle, XCircle } from "lucide-react";

const API = window.location.origin + "/api";

export default function AutoLogin() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [message, setMessage] = useState("Signing you in...");

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token) {
      setStatus("error");
      setMessage("Invalid link. No token provided.");
      return;
    }

    const performAutoLogin = async () => {
      try {
        const response = await axios.get(`${API}/auth/auto-login/${token}`, {
          withCredentials: true
        });

        if (response.data.success) {
          setStatus("success");
          setMessage("Login successful! Redirecting...");

          // Use window.location for a full page reload to ensure auth state updates
          setTimeout(() => {
            window.location.href = response.data.redirect;
          }, 800);
        }
      } catch (error) {
        setStatus("error");
        setMessage(error.response?.data?.detail || "Auto-login failed. Please try manual login.");
      }
    };

    performAutoLogin();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-neutral-950 to-neutral-900 flex items-center justify-center">
      <div className="text-center p-8">
        {status === "loading" && (
          <>
            <Loader2 className="w-16 h-16 text-amber-500 animate-spin mx-auto mb-4" />
            <h1 className="text-2xl font-serif text-foreground mb-2">Étoile</h1>
            <p className="text-neutral-400">{message}</p>
          </>
        )}

        {status === "success" && (
          <>
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h1 className="text-2xl font-serif text-foreground mb-2">Welcome!</h1>
            <p className="text-neutral-400">{message}</p>
          </>
        )}

        {status === "error" && (
          <>
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h1 className="text-2xl font-serif text-foreground mb-2">Login Failed</h1>
            <p className="text-neutral-400 mb-4">{message}</p>
            <a
              href="/auth"
              className="px-6 py-2 bg-amber-500 text-black rounded-lg hover:bg-amber-400 transition inline-block"
            >
              Go to Login
            </a>
          </>
        )}
      </div>
    </div>
  );
}
